import { faUser } from '@fortawesome/pro-light-svg-icons';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { LEGAL_PERSON } from 'data-layer-cr/dist/constants/customerTypes';
import { Quotation } from 'data-layer-cr/dist/models';
import { dateFormat } from 'design-system';
import { useMemo } from 'react';
import genderString from 'src/functions/genderString';
import InformationCardLayout from './InformationCardLayout';
import InformationRow from './InformationRow';

const { dateFromServerString } = dateFormat;

const useStyle = makeStyles(() => ({
  subtitleContainer: {
    textTransform: 'capitalize',
    marginTop: 20,
    fontWeight: 900,
    fontSize: 17,
  },
}));

type Props = {
  quotation: Quotation;
};

type ContractingData = {
  fullName: string;
  phone: string;
  email: string;
};

const ContractingInformationCard = ({ quotation }: Props): JSX.Element => {
  const classes = useStyle();

  const contractingData = useMemo((): ContractingData => {
    if (quotation.customerType === LEGAL_PERSON) {
      return {
        fullName: quotation.legalEntity?.name || '',
        phone: quotation.legalEntity?.phone || '',
        email: quotation.legalEntity?.email || '',
      };
    }
    const {
      customer: { phone, email, firstName, lastName },
    } = quotation;
    return { fullName: `${firstName} ${lastName}`, phone, email };
  }, [quotation]);

  const driver = useMemo(() => quotation.units[0].unit.driver, [quotation]);

  return (
    <InformationCardLayout
      data-testid="contracting-information-card"
      icon={faUser}
      title="Datos del contratante"
    >
      <Grid item xs={12}>
        <Typography
          data-testid="customer-name"
          className={classes.subtitleContainer}
        >
          {contractingData.fullName}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <InformationRow
          data-testid="birthday-row"
          description="Fecha de nacimiento"
          value={dateFromServerString(driver.birthday)}
        />
      </Grid>
      <Grid item xs={12}>
        <InformationRow
          data-testid="gender-row"
          description="Género"
          value={genderString(driver.gender)}
        />
      </Grid>
      <Grid item xs={12}>
        <InformationRow
          data-testid="phone-row"
          description="Celular"
          value={contractingData.phone}
        />
      </Grid>
      <Grid item xs={12}>
        <InformationRow
          data-testid="email-row"
          description="Email"
          value={contractingData.email}
        />
      </Grid>
    </InformationCardLayout>
  );
};

export default ContractingInformationCard;
